import { h } from 'preact';
import { getCatalogueTheme } from '../../../lib/Amalgam';
import I18n from '../../../lib/I18n';
// import ArrowLongRight from '../../../molecules/Icon/ArrowLongRight';
import NoSectionIcon from '../../../molecules/Icon/NoSectionIcon';
import './index.less';

function NoSection () {
  const theme = getCatalogueTheme();
  const {
    homepage: { primaryColor }
  } = theme;
  const noSectionIconAndTextColor = primaryColor + '99';
  //   const { themeTextColor } = theme;
  return (
    <div className="noSectionContainer">
      <div class="iconContainer">
        <NoSectionIcon height={65} width={80} color={noSectionIconAndTextColor} />
      </div>
      <div class="noSectionTitle" style={{ color: noSectionIconAndTextColor }}>
        {I18n.t('NO_SECTIONS')}
      </div>
      {/* <div class="learnLink" style={{ borderBottom: `1px solid ${themeTextColor}` }}>
        <a
          href="https://www.youtube.com/channel/UC4ygOF2X_LHOOxC1-OoVbdQ"
          target="_blank"
          rel="noopener noreferrer nofollow"
          style={{ color: themeTextColor }}
        >
          {I18n.t('LEARN_HOW_TO_SETUP_CUSTOM_PAGE')}
          <ArrowLongRight width={20} height={20} className="arrowRight" color={themeTextColor} />
        </a>
      </div> */}
    </div>
  );
}

export default NoSection;
